import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PrincipalCorrespondencesHandoverContent from '../content/principalCorrespondencesHandoverContent';
import addHandoverWrapper from '../handoverWrapper';

class PrincipalCorrespondencesHandover extends React.Component {
	static getTitle() {
		return 'Principal Correspondence';
	}

	render() {
		const report = this.props.report.data[0];
		
		return (
			<PrincipalCorrespondencesHandoverContent report={report} />
		);
	}
}

PrincipalCorrespondencesHandover.propTypes = {
	context: PropTypes.object.isRequired,
	route: PropTypes.object.isRequired,
	report: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	context: state.context
});

export default connect(
	mapStateToProps
)(addHandoverWrapper(
	PrincipalCorrespondencesHandover, {
		title: 'Principal Correspondence',
		className: 'principal-correspondences-handover'
	})
);
